import { useTranslation } from 'react-i18next';

const PSPFailedToLoad = ({ pspName }) => {
    const {t} = useTranslation();
    return (
        <div className="PSPFailedToLoad">{t('error_PSPFailedToLoad', {pspName: pspName.toUpperCase()})}</div>
    );
};

export default PSPFailedToLoad;
